import React, { useState } from "react";
import { Box, Flex, ActionIcon, Tooltip, Text } from "@mantine/core";
import styles from "@scss/custom-components/play-pause-stop.module.scss";

type Variant = "playing" | "paused" | "stopped";

type Props = {
  variant?: Variant;
  onVariantChange?: (variant: Variant) => Promise<boolean> | void;
  playStopToggle?: boolean;
};

export const CustomPlayPauseStop: React.FC<Props> = ({
  variant: initialVariant = "stopped",
  onVariantChange,
  playStopToggle = false,
}) => {
  const [variant, setVariant] = useState<Variant>(initialVariant);

  const handlePlayToggle = async () => {
    if (playStopToggle) {
      // When pause is hidden, toggle between playing and stopped
      if (variant === "playing") {
        const success = await onVariantChange?.("stopped");
        if (success !== false) {
          setVariant("stopped");
        }
      } else {
        const success = await onVariantChange?.("playing");
        if (success !== false) {
          setVariant("playing");
        }
      }
    } else {
      // Normal behavior
      const success = await onVariantChange?.("playing");
      if (success !== false) {
        setVariant("playing");
      }
    }
  };

  const handlePlay = async () => {
    const success = await onVariantChange?.("playing");
    if (success !== false) {
      setVariant("playing");
    }
  };

  const handlePause = async () => {
    const success = await onVariantChange?.("paused");
    if (success !== false) {
      setVariant("paused");
    }
  };

  const handleStop = async () => {
    const success = await onVariantChange?.("stopped");
    if (success !== false) {
      setVariant("stopped");
    }
  };

  return (
    <Box
      className={[
        styles.container,
        variant ? styles[variant] : "",
        playStopToggle ? styles.hidePause : "",
      ].join(" ")}
    >
      <Flex align="center" gap="xs">
        {playStopToggle ? (
          <Flex
            align="center"
            gap="8px"
            onClick={handlePlayToggle}
            style={{ cursor: "pointer" }}
          >
            <ActionIcon
              size="xs"
              className={[
                styles.icon,
                variant === "playing" ? styles.iconSelected : "",
                variant !== "playing" ? styles.playIcon : "",
              ].join(" ")}
            >
               <></>
            </ActionIcon>
            <Text size="sm" pt="2px" className="grey300" fw={500}>
              {variant === "playing" ? "Stop" : "Play"}
            </Text>
          </Flex>
        ) : (
          <>
            <Tooltip label="Play">
              <ActionIcon
                size="xs"
                className={[
                  styles.icon,
                  variant === "playing" ? styles.iconSelected : "",
                ].join(" ")}
                onClick={handlePlay}
              >
                <></>
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Pause">
              <ActionIcon
                size="xs"
                className={[
                  styles.icon,
                  variant === "paused" ? styles.iconSelected : "",
                ].join(" ")}
                onClick={handlePause}
              >
                <></>
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Stop">
              <ActionIcon
                size="xs"
                className={[
                  styles.icon,
                  variant === "stopped" ? styles.iconSelected : "",
                ].join(" ")}
                onClick={handleStop}
              >
                <></>
              </ActionIcon>
            </Tooltip>
          </>
        )}
      </Flex>
    </Box>
  );
};
